import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCT_FORMING_ANALYSIS_MAIN',
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/product/forming/analysis/main`;
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += `?${key}=${param[key]}`;
        } else {
          url += `&${key}=${param[key]}`;
        }
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [data || [], isRequestSuccessed];
});
